import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Header from "./Header.js";
import "../App.css"
import { Link } from "react-router-dom";
import {formatDate, parseResponseJSON,dateDifference, formatDateText} from "./CommonFunctions";
import Form from 'react-bootstrap/Form';
import CommonComponents from "./CommonComponents.js";
import { Rate, Badge } from "rsuite";
import { Table } from 'react-bootstrap'
import { AddRepair } from "./AddRepair.js";
import NewPost from "./AddImage.js"
import { 
  Box, 
  Checkbox, 
  Container,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
} from "@mui/material";
import { DataGrid, gridClasses, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import {
  Dialog,
  DialogContent,
  IconButton,
  AppBar,
  Toolbar
} from "@mui/material";
import {
  Add as AddIcon,
  Print as PrintIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

export const Repairs=()=>{
    const [description,setDescription]=useState("");
    const [assignedto,setAssignedto]=useState("");
    let [repairStatus,setRepairStatus]=useState("Yet to be assigned");
    const [scheduledDate,setScheduledDate]=useState("");
    let [active,setActive]=useState("");
    const [completedDate,setCompletedDate]=useState(null)
    const [roomNumber,setRoomNumber]=useState("");
    const [repairs, setRepairs] = useState([]);
    const [isAddRepair,setIsAddRepair]=useState(false);
    const [isImageUpload,setIsImageUpload] = useState(false);
    const [repairId,setRepairId]=useState("");
    const [responseForRepair,setResponseForRepair]=useState("");
    const [showDeleteRepairPopup, setShowDeleteRepairPopup]=useState(false);
    const [repairStatusFilter, setRepairStatusFilter] =useState("Incomplete")
    const [managerRatingOnRepair, setManagerRatingOnRepair] = useState("");
    const [managerComments,setManagerComments]=useState("");
    const [allRooms,setAllRooms]=useState([]);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortType, setSortType] = useState("asc");
    const [loading, setLoading] = useState(false);
    const {displayNotificationMessage}=useContext(CommonComponents);
    const {roomId} = useParams();
    const [list,setList] = useState([]);
    const [showPrintSelectedRows,setShowPrintSelectedRows] = useState(false)
    const [roomFilterValue, setRoomFilterValue] = useState("all");
    
    const url=process.env.REACT_APP_SERVER_URL;
    
    useEffect(() => {
      if(roomId){
        getRepairsByRoomId(roomId);
        setRoomFilterValue(roomId);
      }
      else{
        searchRepairByStatus("Incomplete");
      }
      getAllRooms();
    }, []);

   const getAllRooms=async()=>{
    try{
      await axios.get(`${url}/rooms`).then((responseForAllRooms)=>{
        setAllRooms(responseForAllRooms.data);
      })
    }
    catch(error){
      console.log(error);
    }
   }
   
   const getRepairsByRoomId = async(roomId)=>{
    try{
      await axios.get(`${url}/repairs/getRepairsByRoomId/${roomId}`).then((responeForGettingRepairsByroomId)=>{
        setRepairs(responeForGettingRepairsByroomId.data)
      })
    }
    catch(error){
      console.log(error);
      displayNotificationMessage("error",error.response.data);
    }
   }
   
    const getRepairs = async () => {
      try{
      await axios.get(`${url}/repairs`).then((responseForGettingRepairs)=>{
        setRepairs(responseForGettingRepairs.data);
      });
      }
      catch(error){
        console.log(error);
        displayNotificationMessage("error",error.response.data);
      }
    };

    const handleShowAddRepair=(repairId)=>{
      if(repairId){
        setRepairId(repairId);
        getRepairById(repairId);
      }
      else{
        setRoomNumber("");
        setDescription("");
        setActive("");
        setAssignedto("");
        setScheduledDate(null);
        setCompletedDate(null);
        setRepairId("");
        setRepairStatus("");
        setResponseForRepair("");
        setManagerRatingOnRepair(0);
      }
      setIsAddRepair(true);
    }
    
    const handleAddImage = (repairId) =>{
      setIsImageUpload(true);
      if(repairId){
        setRepairId(repairId)
      }
    }

    const handleCloseAddRepair=()=>{
      setIsAddRepair(false);
      setRepairId("")
      setResponseForRepair("");
      setManagerRatingOnRepair(0)
    }

    const handleCloseDeleteRepairPopup=()=>{
      setRepairId("")
      setShowDeleteRepairPopup(false);
      setResponseForRepair("")
    }
    
    const handleShowDeleteRepairPopup=(repairId)=>{
      setRepairId(repairId)
      setShowDeleteRepairPopup(true)
    }

    const deleteRepair=async(e)=>{
      if(e) e.preventDefault()
      try {
        await axios.delete(`${url}/repairs/${repairId}`).then((responseForeDeletingRepair)=>{
          displayNotificationMessage("warning","Deleted Repair Ticket Successfully");
          handleCloseDeleteRepairPopup()
        });
        getRepairs();
      } catch (error) {
        console.log(error);
        displayNotificationMessage("error",error.response.data);
      }
    }
    
    const getRepairById=async(repairId)=>{
      try{
      let responseForRepairById = await axios.get(`${url}/repairs/${repairId}`);
      const tempResponseForRepairId=parseResponseJSON(responseForRepairById.data);
      setRoomNumber(tempResponseForRepairId[0].roomid);
      setDescription(tempResponseForRepairId[0].description);
      setActive(tempResponseForRepairId[0].active);
      setAssignedto(tempResponseForRepairId[0].assignedto);
      setScheduledDate(tempResponseForRepairId[0].scheduledDate);
      setCompletedDate(tempResponseForRepairId[0].completedDate);
      setRepairStatus(tempResponseForRepairId[0].status);
      setManagerRatingOnRepair(tempResponseForRepairId[0].managerRatingOnRepair)
    }
    catch(error)
    {
      console.log(error);
      displayNotificationMessage("error",error.response.data);
    }
  }
  
  const searchRepairByStatus=async(targetValue)=>{
    try{
      setRepairStatusFilter(targetValue);
      if(targetValue=="all"){
        getRepairs();
      }
      else{
        await axios.post(`${url}/repairs/searchRepairByStatus`,{
          targetValue
        }).then((responseForSearchingRepairByStatus)=>{
          setRepairs(responseForSearchingRepairByStatus.data)
        })
      }
    }catch(error){
      console.log(error);
      displayNotificationMessage("error",error.response.data);
    }
  }

  const handleRoomFilter = (roomId) => {
    setRoomFilterValue(roomId);
    if (roomId === "all") {
      searchRepairByStatus(repairStatusFilter);
    } else {
      getRepairsByRoomId(roomId);
    }
  };

  function handleCheckBoxList(row) {
    if (list.some((item) => item.id === row.id)) {
      const updatedList = list.filter((item) => item.id !== row.id);
      setList(updatedList);
    } else {
      setList((prevList) => [...prevList, row]);
    }
  }
  
  const columns =[
    { field: ``, headerName: '', width: 80, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
          return <Checkbox 
          checked={list.some((item) => item.id === currentRow.id)}
          onChange={() => {
            handleCheckBoxList(currentRow);
          }}></Checkbox>
    } },
    { field: `id`, headerName: 'Ticket No.', width: 80, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
          return <Link onClick={(e)=>handleShowAddRepair(currentRow.id)}>{currentRow.id}</Link>
    } },
    { field: `roomid`, headerName: 'Room No.', width: 80, align: 'left' ,
        renderCell:(params)=>{
          const currentRow=params.row;
            return <>{currentRow.roomid}</>
    } },
    { field: 'description', headerName: 'Description', width: 250, align: 'left',
      renderCell: (params) => {
        return <div style={{ lineHeight: "1.5em",whiteSpace: 'normal', wordBreak: 'break-all',overflowWrap: "anywhere",
          display: "block" }}>
          {params.row.description}
        </div>
      },
     },
     { field: `priority`, headerName: 'Priority', width: 80, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
          return <>{currentRow.priority}</>
  } },
    { field: 'scheduledDate', headerName: 'Scheduled at', width: 150, align: 'left' ,
        renderCell:(params)=>{
          const currentRow=params.row;
          return currentRow.scheduledDate ? formatDateText(currentRow.scheduledDate) : null;       
    } },
    { field: 'assignedto', headerName: 'Assigned to', width: 150, align: 'left' },
    { field: 'status', headerName: 'Status', width: 150, align: 'left' },
    { field: 'createdAt', headerName: 'Created at', width: 150, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return currentRow.createdAt ? formatDateText(formatDate(currentRow.createdAt)) : null;       
     } },
     { field: 'daysOpen', headerName: 'Days Open', width: 100, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return dateDifference(currentRow.createdAt,currentRow.completedDate ? currentRow.completedDate : new Date());       
     } },
    { field: 'completedDate', headerName: 'Completed at', width: 150, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return currentRow.completedDate ? formatDateText(currentRow.completedDate) : null;       
    } },
    { field: 'managerComments', headerName: 'Manager Comments', width: 200, align: 'left' },
    { field: 'managerRatingOnRepair', headerName: 'Rating', width: 150, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return <Rate size="xs" style={{width:"100px"}} 
        value={currentRow.managerRatingOnRepair} readOnly></Rate>        
    } },
    { field: 'actions', headerName: 'Actions', width: 100, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return <>
        <Link
              onMouseMove={(e)=>handleCloseAddRepair()}
              onTouchMove={(e)=>handleCloseAddRepair()}
                onClick={()=>handleShowAddRepair(currentRow.id)}
              >
                Edit
              </Link>
              <br></br>
              <Link
                onClick={()=>handleShowDeleteRepairPopup(currentRow.id)}
              >
                Delete
              </Link>
              <br></br>
              <Badge content={currentRow.imageCount ? currentRow.imageCount : 0} size="0.5rem" >  
              <Link 
              onClick={()=>handleAddImage(currentRow.id)}
              >Images </Link>
              </Badge>
              <br></br>
        </>
    } },
  ];
  
  function handleClosePrintSelectedRows(){
    setShowPrintSelectedRows(false);
  }
  
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

    return (
      <>
        <Header/>
        
        <Container maxWidth="xl" sx={{ py: 2 }}>
          {/* Single Line Header */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2,
            mb: 1,
            pb: 1,
          }}>
            {/* Title */}
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Repair Tickets
            </Typography>

            {/* Count */}
            

            {/* Spacer */}
            <Box sx={{ flexGrow: 1 }} />

            <Typography variant="h6" color="text.secondary" sx={{ mx: 2 }}>
              Total: <strong>{repairs.length}</strong>
              {list.length > 0 && (
                <> | Selected: <strong>{list.length}</strong></>
              )}
            </Typography>

            {/* Status Filter */}
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={repairStatusFilter}
                label="Status"
                onChange={(e) => searchRepairByStatus(e.target.value)}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="Incomplete">Incomplete</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
                <MenuItem value="Need management action">Needs Action</MenuItem>
              </Select>
            </FormControl>

            {/* Room Filter */}
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>Room</InputLabel>
              <Select
                value={roomFilterValue}
                label="Room"
                onChange={(e) => handleRoomFilter(e.target.value)}
              >
                <MenuItem value="all">All Rooms</MenuItem>
                {allRooms.map((room) => (
                  <MenuItem key={room.id} value={room.id}>
                    Room {room.id}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Print Button */}
            <Button
              startIcon={<PrintIcon />}
              onClick={() => setShowPrintSelectedRows(true)}
              variant="outlined"
              disabled={list.length === 0}
            >
              Print ({list.length})
            </Button>

            {/* New Ticket Button */}
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={()=>handleShowAddRepair(null)}
            >
              New Ticket
            </Button>
          </Box>

          {/* Table - Keep as is */}
          <Box
            sx={{
              height: 550,
              width: '100%',
              '& .actions': {
                color: 'text.secondary',
              },
              '& .textPrimary': {
                color: 'text.primary',
              },
            }}
          >
            <DataGrid 
              rows={repairs} 
              columns={columns} 
              getRowHeight={() => 'auto'} 
              getRowId={(row) => row.id} 
              slots={{
                toolbar: CustomToolbar,
              }}
              sx={{
                [`& .${gridClasses.cell}`]: {
                  py: 1.5,
                },
              }}
            />
          </Box>  
        </Container>

        {/* Dialogs */}
        {isAddRepair && <AddRepair 
          value={{repairId: repairId}} 
          repairs={repairs} 
          setRepairs={setRepairs}
          getRepairs={getRepairs} 
          handleCloseAddRepair={handleCloseAddRepair}
        />}
        
        {isImageUpload && (
          <NewPost
            showDialog={isImageUpload}
            setShowDialog={setIsImageUpload}
            repairId={repairId}
          />
        )}

        {/* Delete Dialog */}
        <Dialog open={showDeleteRepairPopup} onClose={handleCloseDeleteRepairPopup} maxWidth="xs">
          <Box sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Delete Repair Ticket?
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Are you sure you want to delete this repair ticket? This action cannot be undone.
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button onClick={handleCloseDeleteRepairPopup}>Cancel</Button>
              <Button onClick={(e)=>deleteRepair(e)} variant="contained" color="error">
                Delete
              </Button>
            </Stack>
          </Box>
        </Dialog>

        {/* Print Dialog - FULL FUNCTIONALITY */}
        <Dialog
          fullScreen
          open={showPrintSelectedRows}
          onClose={handleClosePrintSelectedRows}
        >
          <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClosePrintSelectedRows}
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
                Print Preview - {list.length} Selected Tickets
              </Typography>
              <Button 
                autoFocus 
                color="inherit" 
                startIcon={<PrintIcon />}
                onClick={() => window.print()}
              >
                Print
              </Button>
            </Toolbar>
          </AppBar>
          <DialogContent sx={{ pt: 4 }}>
            <TableComponent rows={list} />
          </DialogContent>
        </Dialog>
      </>
    );
}

const TableComponent = ({ rows }) => {
  return (
    <Table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid black"}}>
      <thead style={{padding:"1.4rem"}}>
        <tr>
          <th>Ticket No.</th>
          <th>Room No.</th>
          <th>Description</th>
          <th>Priority</th>
          <th>Scheduled at</th>
          <th>Assigned to</th>
          <th>Days Open</th>
          <th>Completed at</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <tr key={index} style={{ borderBottom: "1px solid black" }}>
            <td>{row.id}</td>
            <td style={{fontSize:"1.4rem"}}><b>{row.roomid}</b></td>
            <td style={{fontSize:"1.4rem"}}>{row.description}</td>
            <td>{row.priority}</td>
            <td>{row.scheduledDate ? formatDateText(row.scheduledDate) : ''}</td>
            <td>{row.assignedto}</td>
            <td>{dateDifference(row.createdAt,row.completedDate ? row.completedDate : new Date())}</td>
            <td>{row.completedDate ? formatDateText(row.completedDate) : ''}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};